import React, { useEffect } from 'react';
import { composer } from '../../../component-decorators/composer';
import { Box, Button, Text, Divider, Popover } from 'wix-style-react';
import { sendUpgradeSiteBi } from '../../../bi/biEvents';
import { EditorType } from '../../manage-installed-apps-page';
import { canUsePremiumApp } from '../../..';
import { biLogger } from '../../../bi';
import s from './app-card.scss';
import { CounterHolidaySaleExport } from '@wix/app-market-collection-widget';
export var UpgradeButton = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var app = _a.app, msid = _a.msid, origin = _a.origin, isBusinessApp = _a.isBusinessApp, editorType = _a.editorType, getAppInstance = _a.getAppInstance, t = _a.t, experiments = _a.experiments, siteIsPremium = _a.siteIsPremium, isActionRequiredApp = _a.isActionRequiredApp, showHolidaySale = _a.showHolidaySale, locale = _a.locale;
    var appId = app.webSolutionBase.id;
    var isBundleApp = (appId === '13ee53b4-2343-b641-c84d-056d2e6ed2e6' ||
        appId === '130cabc9-eda6-d9d8-ed5f-67815d65951e') &&
        app.isUpgraded === true;
    var showUpgradeSite = isBusinessApp ||
        !canUsePremiumApp(app, siteIsPremium);
    var buttonText = showUpgradeSite
        ? t('manage-apps.app-card.upgrade-site-button')
        : t('manage-apps.app-card.upgrade');
    var buttonAction = showUpgradeSite
        ? handleUpgradeSiteClick
        : handleUpgradeAppClick;
    var buttonOnClick = function (clickInsideSaleTooltip) {
        if (isActionRequiredApp) {
            biLogger
                .appMarketManageAppsActionRequiredClick({
                msid: msid,
                app_id: app.webSolutionBase.id,
                market: origin,
                action_cta: 'upgrade_site',
            })
                .catch(function (e) { return console.log(e); });
        }
        if (clickInsideSaleTooltip) {
            biLogger
                .appMarketSaleUpgradePlanClick({
                msid: msid,
                app_id: app.webSolutionBase.id,
                market: origin,
                referral_tag_type: 'manage-apps',
                sale_name: 'nov21',
                slug_id: 'pre-holiday-sale',
            })
                .catch(function (e) { return console.log(e); });
        }
        else {
            var sale_name = showHolidaySale ? 'nov21' : '';
            sendUpgradeSiteBi(app, origin, msid, editorType, sale_name);
        }
        buttonAction(app, origin, msid, app.instance, editorType, isBundleApp);
    };
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(false), shown = _b[0], changeIsShown = _b[1];
    useEffect(function () {
        if (isActionRequiredApp) {
            biLogger
                .appMarketSpotlightArticle({
                action_cta: 'upgrade_site',
                app_id: app.webSolutionBase.id,
                msid: msid,
                market: origin,
            })
                .catch(function (e) { return console.log(e); });
        }
    }, []);
    return (React.createElement("div", null, showHolidaySale && !isBundleApp ? (React.createElement(React.Fragment, null,
        React.createElement(Popover, { showArrow: true, shown: shown, appendTo: "window", placement: "top-end", onMouseEnter: function () { return changeIsShown(true); }, onMouseLeave: function () { return changeIsShown(false); }, zIndex: 10000 },
            React.createElement(Popover.Element, null,
                React.createElement(Button, { size: 'tiny', priority: 'secondary', onClick: function () { return buttonOnClick(false); }, className: s.upgradeSaleButton, dataHook: "upgrade-button" }, buttonText)),
            React.createElement(Popover.Content, null,
                React.createElement(Box, { padding: "30px 43px 20px 28px", direction: "vertical", width: "536px" },
                    React.createElement(Box, { direction: 'horizontal', align: 'space-between' },
                        React.createElement(Text, { skin: "error", className: s.saleColor, weight: "bold" }, t('manage-apps.holiday-sale.notification.title')),
                        React.createElement(CounterHolidaySaleExport, { locale: locale, manageAppsToolTip: true })),
                    React.createElement(Box, { width: '355px', marginTop: '-10px' },
                        React.createElement(Text, { skin: "standard", weight: "thin" }, t('manage-apps.holiday-sale.notification.subtitle'))),
                    React.createElement(Box, { minWidth: '128px', marginTop: '18px' },
                        React.createElement(Button, { size: 'small', priority: 'primary', onClick: function () { return buttonOnClick(true); }, className: s.holidayColor, dataHook: "upgrade-button" }, t('manage-apps.holiday-sale.notification.cta'))),
                    React.createElement(Box, { marginTop: '24px', marginBottom: '12px' },
                        React.createElement(Divider, null)),
                    React.createElement(Text, { skin: "standard", secondary: true, weight: "thin", size: "tiny" }, t('manage-apps.holiday-sale.notification.disclaimer'))))))) : (React.createElement(Button, { size: 'tiny', priority: !canUsePremiumApp(app, siteIsPremium)
            ? 'primary'
            : 'secondary', skin: 'premium', onClick: function () { return buttonOnClick(false); }, className: s.upgradeButtonAlign, dataHook: "upgrade-button" }, buttonText))));
});
var handleUpgradeSiteClick = function (app, origin, msid, editorType) {
    var domain = editorType === EditorType.EDITORX
        ? "manage.editorx.com"
        : "premium.wix.com";
    window.open("https://" + domain + "/wix/api/premiumStart?appDefId=" + app.webSolutionBase.id + "&siteGuid=" + msid + "&pp_origin=manage_apps_" + origin, '_blank');
};
var handleUpgradeAppClick = function (app, origin, msid, instance, editorType, isAppInBundle) {
    if (app.webSolutionBase.pricing &&
        app.webSolutionBase.pricing.externalPricingPageUrl) {
        window.open(app.webSolutionBase.pricing.externalPricingPageUrl + "?instance=" + instance, '_blank');
    }
    else {
        var domain = editorType === EditorType.EDITORX ? "manage.editorx.com" : "www.wix.com";
        var bundleAppString = isAppInBundle
            ? "&isAppInBundle=" + isAppInBundle
            : '';
        window.open("https://" + domain + "/apps/upgrade/" + app.webSolutionBase.id + "?metaSiteId=" + msid + "&pp_origin=manage_apps_" + origin + "&publishedVersion=" + app.publishedVersion + bundleAppString, '_blank');
    }
};
//# sourceMappingURL=upgrade-button.js.map